import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Plumbing = createSvgIcon(
  <path d="M0 0v2.25h1.5V7.5H0v2.25h1.5v4.5c0 5.385 4.365 9.75 9.75 9.75S21 19.635 21 14.25h1.5V12H21v-1.125c0-.613.295-1.158.75-1.5V10.5H24V0h-2.25v1.567c-4.647.556-8.25 4.511-8.25 9.308V12H12v2.25h1.5a2.25 2.25 0 0 1-4.5 0v-4.5h1.5V7.5H9V2.25h1.5V0H0Zm6.75 2.25V7.5h-3V2.25h3Zm4.5 16.5a4.5 4.5 0 0 0 4.5-4.5h3a7.5 7.5 0 0 1-15 0v-4.5h3v4.5a4.5 4.5 0 0 0 4.5 4.5Zm7.5-6.75h-3v-1.125c0-3.552 2.6-6.497 6-7.037v3.067c-1.731.49-3 2.082-3 3.97V12Z" />,
  'Plumbing'
);

export { Plumbing };